<template>
  <div>
    <p class="title">功能</p>
    <ul>
      <li @click="jumpE" :class="{ active: isactive == 1 }">报名</li>
      <li @click="jumpA" :class="{ active: isactive == 2 }">查成绩</li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isactive: 0,
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      if (to.path == "/enroll") {
        this.isactive = 1;
      } else if (to.path == "/achievement") {
        this.isactive = 2;
      }
    },
  },
  methods: {
    jumpE() {
      this.$router.push("/enroll");
      this.isactive = 1;
    },
    jumpA() {
      this.$router.push("/achievement");
      this.isactive = 2;
    },
  },
  mounted(){
console.log(this.$route.path)
 if (this.$route.path == "/enroll") {
        this.isactive = 1;
      } else if (this.$route.path == "/achievement") {
        this.isactive = 2;
      }
}
};
</script>
<style scoped>
ul li {
  list-style: none;
  padding: 20px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
}
li:hover {
  background: #f7f7f7;
}
ul {
  padding: 0px;
  margin: 0px;
}
.title {
  color: #2d76f9;
  font-weight: 600;
}
.active {
  background: #f9f9f9;
  color: #2d76f9;
  border-left: 2px solid #2d76f9;
}
</style>